import { GLOBAL_DISCOVERY_NOTIFICATIONS_QUERY_KEY } from "@entities/global-discovery/constants";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { REPORTS_LIST_QUERY_KEY } from "../constants";
import { ReportService } from "../services/Report.servie";

export function useAddMediaLinksToReport(reportId: string) {
  const {
    mutate: addMediaLinksToReport,
    isLoading: isAdding,
    isSuccess: isAdded,
    data,
  } = useMutation<{ reportingMedialinks: string[] }, BackednResponse<object>>({
    mutationFn: ({ reportingMedialinks }) =>
      ReportService.addMediaLinksToReport(
        reportId,
        reportingMedialinks
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...GLOBAL_DISCOVERY_NOTIFICATIONS_QUERY_KEY],
      });
      c.invalidateQueries({ queryKey: [REPORTS_LIST_QUERY_KEY] });
    },
  });

  return {
    addMediaLinksToReport,
    isAdding,
    isAdded,
    data,
  };
}
